// Hair Products Data

export const hairProducts = [
  {
    id: 'exos-gfc-therapy',
    name: 'Exos-GFC',
    subtitle: 'Exosome + Growth Factor Hair Therapy',
    image: '/images/hairproducts/hairproduct2.png',
    shortDescription:
      'Advanced hair regeneration therapy combining Exosomes and Growth Factor Concentrate (GFC) to stimulate hair regrowth, strengthen follicles, and rejuvenate scalp health.',
    suitableFor:
      'Men and women with hair loss, hair thinning, androgenetic alopecia, or post-hair transplant care',
    keyBenefits: [
      { text: 'Activates dormant hair follicles' },
      { text: 'Promotes natural hair regrowth' },
      { text: 'Reduces hair fall and thinning' },
      { text: 'Improves hair density and scalp health' }
    ],
    keyIngredient: {
      name: 'Exosomes + Growth Factor Concentrate (GFC)',
      description:
        'Exosomes enhance cellular communication and tissue repair, while Growth Factor Concentrate (GFC) stimulates follicle activity, collagen production, and scalp rejuvenation.'
    },
    texture: {
      title: 'Injectable Regenerative Therapy',
      features: [
        'Medical-grade formulation',
        'Follicle-level regeneration',
        'Improves scalp microcirculation',
        'Supports long-term hair growth'
      ]
    },
    howToUse: [
      'Performed by trained medical professional',
      'Administered through scalp injections',
      'Multiple sessions as advised by specialist',
      'Gradual improvement over 2–6 months'
    ]
  },

  {
    id: 'fetoscell-follicle-pdrn',
    name: 'FetoScell Follicle',
    subtitle: 'PDRN Hair Regeneration Therapy',
    image: '/images/hairproducts/hairproduct3.jpeg',
    shortDescription:
      'Advanced polynucleotide (PDRN) hair therapy with Hyaluronic Acid designed to stimulate hair follicles, restore scalp health, and promote natural hair regrowth.',
    suitableFor:
      'Men and women with hair thinning, hair loss, weakened follicles, or scalp aging',
    keyBenefits: [
      { text: 'Stimulates hair follicle regeneration at DNA level' },
      { text: 'Activates dormant hair follicles' },
      { text: 'Improves scalp hydration and elasticity' },
      { text: 'Strengthens hair roots and reduces hair loss' }
    ],
    keyIngredient: {
      name: 'PDRN + Hyaluronic Acid',
      description:
        'PDRN derived from salmon enzymes acts as a cellular regenerator and collagen stimulator, while Hyaluronic Acid deeply hydrates the scalp and improves tissue elasticity.'
    },
    texture: {
      title: 'Injectable Regenerative Solution',
      features: [
        'Bioreparant formulation',
        'DNA-level follicle stimulation',
        'Improves scalp microcirculation',
        'Supports long-term follicle health'
      ]
    },
    howToUse: [
      'Professional scalp injection procedure',
      'Course of treatments as prescribed by specialist',
      'Administered using papular or linear technique',
      'Results gradually improve over several weeks'
    ]
  },

//   {
//   "id": "bcomplex",
//   "name": "B-Complex",
//   "subtitle": "Vitamin B Complex Hair Revitalization Therapy",
//   "image": "/images/hairproducts/hairproduct1.png",
//   "shortDescription": "Being a vitamin complex with Vitamin B1, B3, B6, B9 and B12, B-Complex supports cellular regeneration and nourishment, helping improve overall hair and scalp condition.",
  
//   "keyBenefits": [
//     { text: 'Promotes hair cell regeneration and renewal' },
//     { text: 'Reduces hair loss and improves scalp health' },
//     { text: 'Strengthens hair roots and enhances growth' }
//   ],
//   "keyIngredient": {
//     "name": "Thiamine HCL, Niacinamide, Pyridoxine, Folic Acid, Cyanocobalamin, Pentapeptide-33",
//     "description": "B-Complex vitamins work synergistically to support cellular metabolism, enhance scalp health, and promote strong, healthy hair growth."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": [
//       'Clear liquid formula',
//       'Easily absorbed',
//       'Non-irritating formula'
//     ]
//   },
//   "howToUse": [
//     'Apply 1 ampoule per session',
//     'Use weekly for optimal results',
//     'Can be combined with other treatments'
//   ],
//   "suitableFor": "Hair loss prevention and scalp health",
//   "presentation": "Box 20 x 5 ml ampoules",
//   "category": "hair-therapy",
//   "featured": false
// },

// {
//   "id": "biotin-hidrizin",
//   "name": "Biotin Hidrizin",
//   "subtitle": "Vitamin B7 Hair Growth & Strengthening Therapy",
//   "image": "/images/hairproducts/hairproduct4.png",
//   "shortDescription": "Biotin is a coenzyme known as Vitamin B7 that supports scalp health and assists in new cell production. Biotin Hidrizin has been very effective to fight hair loss and to stimulate new hair growth.",
  
//   "keyBenefits": [],
//   "keyIngredient": {
//     "name": "Vitamin B7",
//     "description": ""
//   },
//   "texture": {
//     "title": "",
//     "features": []
//   },
//   "howToUse": [],
//   "suitableFor": "",
//   "presentation": "Box 20 x 2 ml ampoules",
//   "category": "hair-therapy",
//   "featured": false
// },
// {
//   "id": "hair-cocktail",
//   "name": "Hair Cocktail",
//   "subtitle": "Advanced Hair Growth & Strengthening Formula",
//   "image": "/images/hairproducts/hairproduct5.png",
//   "shortDescription": "Hair Cocktail is designed to be applied on the scalp. The combination of Glutathione, Panthenol, Biotin and Orgain nourish and strengthen the hair follicle and promote the growth of new hair.",
  
//   "keyBenefits": [
//     { text: 'Promotes new hair growth and density' },
//     { text: 'Strengthens and nourishes hair follicles' },
//     { text: 'Improves scalp health and circulation' }
//   ],
//   "keyIngredient": {
//     "name": "Glutathione, Panthenol, Biotin, Orgain, Methylxanthine-Mannosidic",
//     "description": "A comprehensive hair-nourishing blend where glutathione detoxifies, panthenol moisturizes, biotin strengthens, orgain provides nutrients, and methylxanthine-mannosidic enhances circulation."
//   },
//   "texture": {
//     "title": "Presentation",
//     "features": [
//       "BOX 5 x 5 ML AMPOULES"
//     ]
//   },
//   "howToUse": [
//     "Apply directly to scalp",
//     "Massage gently into hair roots",
//     "Use 2-3 times weekly for best results"
//   ],
//   "suitableFor": "Hair growth and follicle strengthening",
//   "presentation": "Box 5 x 5 ml ampoules",
//   "category": "hair-therapy",
//   "featured": false
// },

// {
//   id: 'glutathione-hair',
//   name: 'Glutathione Hair Serum',
//   subtitle: 'Premium Hair Strengthening Complex',
//   image: '/images/hairproducts/hairproduct6.png',
//   shortDescription: 'Glutathione acts as a potent antioxidant that protects hair follicles from damage, strengthens hair, and promotes healthier, shinier strands. It helps reduce hair breakage and supports scalp health.',
//   keyBenefits: [
//     { text: 'Protects hair follicles from oxidative stress' },
//     { text: 'Strengthens hair strands' },
//     { text: 'Promotes healthy scalp' },
//     { text: 'Reduces hair breakage' },
//     { text: 'Supports shiny and vibrant hair' }
//   ],
//   keyIngredient: {
//     name: 'Glutathione',
//     description: 'A master antioxidant that supports hair follicle health, reduces oxidative damage, and promotes stronger, healthier, and more resilient hair.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       'BOX 20 x 3 ML AMPOULES'
//     ]
//   },
//   howToUse: [
//     'Apply directly to the scalp or hair roots as directed by professional',
//     'Follow recommended treatment protocol for hair care',
//     'Consistent application for optimal results'
//   ],
//   suitableFor: 'All hair types',
//   category: 'hair-serum',
//   featured: false
// },
// {
//   id: 'hair-scalp-active-ha',
//   name: 'Hair Scalp Active + HA',
//   subtitle: 'Scalp Regeneration & Hair Growth Syringe',
//   image: '/images/hairproducts/hairproduct7.png',
//   shortDescription: 'This syringe was designed to be applied on the scalp. The combination of Glutathione, Panthenol, Biotin, Orgain, and Sodium Hyaluronate nourish and strengthen hair follicles. It stimulates cellular metabolism and promotes hair renewal.',
//   keyBenefits: [
//     { text: 'Stimulates cellular metabolism and hair renewal' },
//     { text: 'Strengthens hair follicles and prevents hair loss' },
//     { text: 'Promotes capillary structure strengthening and growth' }
//   ],
//   keyIngredient: {
//     name: 'Glutathione, Panthenol, Biotin, Orgain, Sodium Hyaluronate',
//     description: 'A comprehensive scalp treatment blend where glutathione detoxifies, panthenol moisturizes, biotin strengthens, orgain provides nutrients, and hyaluronic acid hydrates the scalp.'
//   },
//   texture: {
//     title: 'Presentation',
//     features: [
//       '1 or 2 Syringe x 10ml',
//       'Injectable scalp treatment',
//       'Direct application formula'
//     ]
//   },
//   howToUse: [
//     'Apply directly on the scalp as directed',
//     'Massage gently into scalp area',
//     'Use as part of hair loss treatment protocol'
//   ],
//   suitableFor: 'Hair loss treatment and scalp regeneration',
//   category: 'hair-scalp-therapy',
//   featured: false
// },


{
  id: 'intomedi-hr-peptide',
  name: 'Intomedi HR Peptide',
  subtitle: 'Advanced Peptide-Based Hair Re-Growth',
  image: '/images/hairproducts/hairproduct8.png',
  shortDescription:
    'A peptide-based hair re-growth solution designed to stimulate hair follicles, support the anagen growth phase, and improve overall scalp health. Intended for professional meso/topical application as part of a treatment protocol.',
  suitableFor:
    'Individuals with hair thinning, androgenetic alopecia, or scalp-related hair loss — suitable for both men and women when used under medical supervision',
  keyBenefits: [
    { text: 'Stimulates follicle activity and supports hair regeneration' },
    { text: 'Improves hair density and reduces visible thinning' },
    { text: 'Supports a healthy scalp environment and hair growth cycle' },
    { text: 'Non-surgical option that complements other therapies' }
  ],
  keyIngredient: {
    name: 'HR Peptide Complex',
    description:
      'Peptide formulation specifically developed to activate follicular cells, promote cellular signalling for growth, and support tissue repair in the scalp microenvironment.'
  },
  texture: {
    title: 'Presentation',
    features: ['Sterile amber vial', 'Formulated for mesotherapy or topical professional application']
  },
  howToUse: [
    'Administered by a trained medical professional via mesotherapy or applied following a topical protocol',
    'Follow a course of treatments as recommended by the specialist',
    'Visible improvement typically occurs over several weeks to months'
  ],
  presentation: 'Box with vial(s) — follow supplier packaging',
  category: 'hair-therapy',
  featured: false
},

{
  id: 'heating-therapy-laser-cap',
  name: 'Heating Therapy Laser Cap Laser Hair Therapy',
  subtitle: 'Professional Laser Hair Growth Therapy',
  image: '/images/hairproducts/9.png',
  shortDescription: 'Advanced heating therapy laser cap designed for scalp rejuvenation, hair growth stimulation, and treating hair loss with professional-grade laser technology.',
  keyBenefits: [
    { text: 'Stimulates hair follicle growth and regeneration' },
    { text: 'Reduces hair loss and thinning' },
    { text: 'Improves scalp circulation and health' },
    { text: 'Promotes natural hair thickening' },
    { text: 'Non-invasive and painless treatment' }
  ],
  keyIngredient: {
    name: 'Low-Level Laser Therapy (LLLT)',
    description: 'Professional-grade laser technology combined with heating therapy to stimulate hair follicles and promote healthy hair growth.'
  },
  texture: {
    title: 'Laser Technology',
    features: [
      'Advanced LLLT technology',
      'Integrated heating function',
      'Comfortable cap design',
      'Multiple treatment settings',
      'Wireless portable operation'
    ]
  },
  howToUse: [
    'Ensure scalp is clean and dry',
    'Place cap on head ensuring full coverage',
    'Select treatment mode and intensity',
    'Wear for recommended duration (typically 20-30 minutes)',
    'Use 3-5 times per week for optimal results',
    'Results typically visible after 4-6 weeks of consistent use'
  ],
  suitableFor: 'All hair types, especially those experiencing hair loss or thinning',
  category: 'hair-therapy-device',
  featured: true
},

{
  id: 'dermaheal-hl',
  name: 'Dermaheal HL (Hair Treatment)',
  subtitle: 'Hair Regeneration Treatment Ampoule',
  image: '/images/hairproducts/10.png',
  shortDescription: 'Dermaheal HL formulated to support hair follicle health, stimulate growth, and reduce hair thinning using targeted bioactive components.',
  keyBenefits: [
    { text: 'Stimulates hair follicle activity' },
    { text: 'Improves scalp condition and circulation' },
    { text: 'Supports thicker, healthier hair growth' }
  ],
  keyIngredient: { name: 'Peptide & growth factor blend', description: 'Formulated to nurture hair follicles and support regeneration.' },
  texture: { title: 'Ampoule', features: ['Sterile liquid for mesotherapy or injection'] },
  howToUse: ['Apply via mesotherapy or professional injection protocols'],
  suitableFor: 'Thinning hair and androgenic alopecia under professional guidance',
  category: 'hair-treatment',
  featured: true
 },
 {
  id: 'hair-laser-comb',
  name: 'Hair Laser Comb',
  subtitle: 'Hair Growth Laser Comb',
  image: '/images/hairproducts/11.png',
  shortDescription: 'Portable low-level laser therapy (LLLT) comb to stimulate hair follicles and support hair regrowth for thinning areas.',
  keyBenefits: [
    { text: 'Stimulates hair follicles via LLLT' },
    { text: 'Reduces hair shedding and thinning' },
    { text: 'Improves hair density and scalp circulation' }
  ],
  keyIngredient: {
    name: 'Low-Level Laser Therapy (LLLT)',
    description: 'Non-thermal laser light that promotes cellular activity in hair follicles.'
  },
  howToUse: [
    'Use on clean, dry scalp',
    'Comb slowly across thinning areas for recommended duration',
    'Use 3–5 times per week for best results'
  ],
  suitableFor: 'Thinning hair and early-stage hair loss',
  category: 'hair-device',
  featured: false
 },
 {
  id: 'bosidin-hair-removal-device',
  name: 'BOSIDIN Hair Removal Device Permanent',
  subtitle: 'Professional IPL Hair Removal System',
  image: '/images/hairproducts/12.png',
  shortDescription: 'A professional-grade IPL (Intense Pulsed Light) hair removal device for permanent hair reduction with safe and effective technology.',
  suitableFor: 'Body and facial hair removal for all skin tones',
  keyBenefits: [
    { text: 'Permanent hair reduction with repeated use' },
    { text: 'Fast and pain-free treatment' },
    { text: 'Safe professional-grade IPL technology' },
    { text: 'Can be used on multiple body areas' },
    { text: 'Long-lasting results with maintenance' }
  ],
  keyIngredient: {
    name: 'Intense Pulsed Light (IPL) Technology',
    description: 'Advanced IPL technology targets hair follicles at the root to prevent regrowth while being gentle on surrounding skin.'
  },
  texture: {
    title: 'Device Features',
    features: [
      'Professional IPL hair removal',
      'Multiple power settings',
      'Skin tone sensor for safety',
      'Cordless design for convenience'
    ]
  },
  howToUse: [
    'Start with clean, dry skin',
    'Select appropriate power level for skin tone',
    'Apply device to skin and activate',
    'Move systematically across treatment area',
    'Treat every 2 weeks for optimal results'
  ],
  presentation: 'Professional IPL Device',
  category: 'hair-removal-device',
  featured: false
 },
 {
  id: 'jade-comb-hair-growth',
  name: 'Jade Comb Green For Hair Growth',
  subtitle: 'Traditional Jade Stone Hair Growth Comb',
  image: '/images/hairproducts/13.png',
  shortDescription: 'Premium jade comb with hair growth benefits, combining traditional beauty wisdom with modern scalp care for enhanced hair growth and vitality.',
  suitableFor: 'All hair types, especially those seeking natural hair growth support',
  keyBenefits: [
    { text: 'Stimulates hair growth and follicle health' },
    { text: 'Improves scalp circulation' },
    { text: 'Reduces hair fall and breakage' },
    { text: 'Natural jade stone benefits' },
    { text: 'Soothing scalp massage therapy' }
  ],
  keyIngredient: {
    name: 'Natural Jade Stone',
    description: 'Premium natural jade stone combined with comb technology to provide scalp stimulation, improved blood circulation, and traditional hair growth support.'
  },
  texture: {
    title: 'Tool Features',
    features: [
      'Authentic natural jade stone',
      'Smooth, rounded teeth for gentle massage',
      'Anti-static properties',
      'Durable and long-lasting',
      'Beautiful green jade finish'
    ]
  },
  howToUse: [
    'Use on clean, damp hair',
    'Comb from roots to ends with gentle pressure',
    'Focus on scalp area for massage effect',
    'Use daily for optimal hair growth results',
    'Can be used as part of scalp treatment routine'
  ],
  category: 'hair-growth-tool',
  featured: true
 },
 {
  id: 'nano-needle-cartridge-set',
  name: 'Nano Needle Cartridge Set For Hair Treatment',
  subtitle: 'Precision Microneedling Cartridges (12μm, 36μm, 40μm Options)',
  image: '/images/hairproducts/14.png',
  shortDescription: 'Professional-grade nano needle cartridges in multiple sizes for scalp microneedling therapy to stimulate hair growth and improve scalp health.',
  suitableFor: 'Hair loss treatment, scalp rejuvenation, and hair growth stimulation',
  keyBenefits: [
    { text: 'Multiple needle sizes for different treatment depths' },
    { text: 'Sterile, single-use cartridges' },
    { text: 'Precise microneedling technology' },
    { text: 'Stimulates collagen and hair growth factors' },
    { text: 'Compatible with professional microneedling devices' }
  ],
  keyIngredient: {
    name: 'Medical-Grade Stainless Steel Nano Needles',
    description: 'Precision-engineered nano needles in different gauges (12μm, 36μm, 40μm) for controlled microneedling depth and optimal hair follicle stimulation.'
  },
  texture: {
    title: 'Needle Size Options',
    features: [
      '12μm - Ultra-fine needles for superficial scalp treatment and product penetration',
      '36μm - Standard microneedling depth for hair follicle stimulation',
      '40μm - Deep penetration for intensive scalp rejuvenation',
      'Medical-grade stainless steel construction',
      'Individually packaged and sterilized cartridges'
    ]
  },
  howToUse: [
    'Select appropriate needle size for treatment depth needed',
    'Install cartridge into microneedling pen or device',
    'Ensure secure connection before use',
    'Apply anesthetic cream to scalp if needed',
    'Perform microneedling with gentle, controlled pressure',
    'Dispose of cartridge after single use',
    'Apply hair growth serum or treatment post-procedure',
    'Store unused cartridges in sterile, dry environment'
  ],
  variants: [
    { name: '12μm Ultra-Fine', description: 'Light surface treatment and serum penetration' },
    { name: '36μm Standard', description: 'Standard depth for optimal hair growth stimulation' },
    { name: '40μm Deep', description: 'Deep penetration for intensive scalp recovery' },
    { name: 'Combination Pack', description: 'All three sizes in one set' }
  ],
  suitableFor: 'Hair loss prevention, androgenic alopecia, and scalp rejuvenation under professional guidance',
  category: 'microneedling-cartridge',
  featured: true
 }

 ];

// Helper functions
export const getProductById = (id) => {
  if (!id) return undefined;
  return hairProducts.find(product => product && product.id === id);
};

export const getAllProducts = () => hairProducts;

export default hairProducts;
